import axios from "axios";

const getToken = async () => {
  try {
    // TODO obtener la url en dependencia de los ambientes y ver si viene de firebase
    const tokenUrl = "https://dev-api-rhg.auth.us-east-1.amazoncognito.com/oauth2/token";
    // TODO ver con back como se va a tratar pq esta mal las credenciales aqui
    const client = "57bpm120tdgm18nomgq7qsrsd0";
    const secret = "cd7svqo6noglukistgbdqdqh9bv2vv5ai0g4f738ll8ck34v0e4";
    const credentials = btoa(`${client}:${secret}`);
    const response = await axios.post(
      tokenUrl,
      new URLSearchParams({ grant_type: "client_credentials" }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Basic ${credentials}`,
        },
      }
    );
    return response.data.access_token;
  } catch (error) {
    console.error("Error obteniendo token de persoanl:", error);
    throw error;
  }
};

const getBaseUrl = async () => {
  // TODO obtener la url en dependencia de los ambientes y ver si viene de firebase
  return "https://kp42hw01al.execute-api.us-east-1.amazonaws.com/dev/";
};

const createAxiosInstance = async () => {
  try {
    const baseUrl = await getBaseUrl();
    const token = await getToken();

    const lambdaApiStaff = axios.create({
      baseURL: baseUrl,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });

    lambdaApiStaff.interceptors.request.use(
      (config) => {
        // Solo agrega el token si no está ya presente
        if (token && !config.headers["Authorization"]) {
          config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    return lambdaApiStaff;
  } catch (error) {
    console.error("❌ Error al crear instancia de Axios:", error);
    throw error;
  }
};

export default createAxiosInstance;
